module.exports = __webpack_public_path__ + "images/UserProfile.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/UserProfile.png
// module id = 1361
// module chunks = 0